import { RootState } from 'store/rootSlices';

export const getCurrentLocale = (state: RootState) => state.App.currentLocale;

